import { IconBrandAppleFilled, IconBrandAppstore } from '@tabler/icons-react'
import { capture } from './analytics.js'
import useMacPrice from './lib/useMacPrice.js'
import useAppStorePrice from './lib/useAppStorePrice.js'

export const MAC_CHECKOUT = 'https://buy.polar.sh/polar_cl_9J1kPlq1y224IypY4RoapleyICmoAGnyccyZD0ocFHd'
export const MAC_APP_STORE = '/api/mac/app-store'

export default function MacPurchaseOptions({ location = 'mac', className = '' }) {
  const price = useMacPrice()
  const appStorePrice = useAppStorePrice()
  const button = 'inline-flex h-14 items-center justify-center gap-2.5 rounded-full px-5 py-3 text-base font-semibold no-underline transition-colors focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-neutral-800'
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`} aria-label="Choose where to buy Keeby for Mac">
      <div className="flex flex-wrap items-center justify-center gap-3">
        <a href={MAC_CHECKOUT} className={`${button} bg-neutral-800 text-white hover:bg-neutral-700`}
          onClick={() => capture('checkout_clicked', { location, platform: 'mac', channel: 'direct' })}>
          <IconBrandAppleFilled size={23} aria-hidden="true" />
          <span>Purchase for Mac</span>
        </a>
        <a href={MAC_APP_STORE} className={`${button} bg-neutral-200 text-neutral-800 hover:bg-neutral-300`}
          onClick={() => capture('download_clicked', { location, platform: 'mac', channel: 'app_store' })}>
          <IconBrandAppstore size={24} stroke={2.1} aria-hidden="true" />
          <span>App Store</span>
          {appStorePrice && <span className="ml-1 rounded-full bg-neutral-600 px-2.5 py-1 text-white">{appStorePrice}</span>}
        </a>
      </div>
      <p className="text-center text-xs text-neutral-600">{price} · One-time purchase</p>
    </div>
  )
}
